const query = gql`
  query RelatedStories($category: ItemId = 0, $first: IntType) {
    allNutritionArticles(
      first: $first
      orderBy: featured_DESC
      filter: {
        OR: [{ categories: { anyIn: [$category] } }, { featured: { eq: true } }]
        archived: { eq: false }
      }
    ) {
      id
      slug
      title
      excerpt
      image {
        alt
        title
        blurUpThumb
      }
      squareImage: image {
        url(
          imgixParams: { w: 320, h: 320, fm: jpg, fit: crop, crop: focalpoint }
        )
      }
      rectangularImage: image {
        url(
          imgixParams: { w: 480, h: 320, fm: jpg, fit: crop, crop: focalpoint }
        )
      }
    }
  }
`

export { query }
